module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs-numbers"
  }, _vm._l((_vm.innerCount), function(num, index) {
    return _c('span', {
      class: _vm.getNumberClass(num, index),
      style: (_vm.innerstyles)
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83e11bee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fragment/number/index.vue
// module id = 242
// module chunks = 0